function colorCoordinateStockIndicators() {
            // Get all elements with the delivery-time class
            const indicators = document.querySelectorAll('.delivery-time');
            
            indicators.forEach(indicator => {
                const text = indicator.textContent.trim().toLowerCase();
                
                // Remove any existing color classes
                indicator.className = indicator.className.replace(/\bstock-\w+/g, '');
                
                // Apply colors based on stock status - font color only
                if (text === 'in stock') {
                    // Green - Available
                    indicator.style.color = '#28a745';
                    
                } else if (text === 'out of stock') {
                    // Red - Not available
                    indicator.style.color = '#dc3545';
                    indicator.textContent = 'Out of stock';
                    
                } else if (text.includes('pre-order')) {
                    // Blue - Pre-order available
                    indicator.style.color = '#007bff';
                    
                } else if (text === 'special order item') {
                    // Purple - Special handling required
                    indicator.style.color = '#6f42c1';
                    
                } else if (text === 'restocking soon') {
                    // Orange - Coming back
                    indicator.style.color = '#fd7e14';
                    
                } else if (text.includes('coming soon')) {
                    // Teal - New product coming
                    indicator.style.color = '#20c997';
                    
                } else if (text === 'awaiting date') {
                    // Gray - Uncertain timeline
                    indicator.style.color = '#6c757d';
                    
                } else {
                    // Default styling for unrecognized statuses
                    indicator.style.color = '#495057';
                }
            });
        }
        
        // Run the color coordination function when the page loads
        document.addEventListener('DOMContentLoaded', function() {
            colorCoordinateStockIndicators();
            observeForChanges();
        });
        
        // Also run after a short delay in case content loads dynamically
        setTimeout(colorCoordinateStockIndicators, 1000);
        
        // Optional: Create a function to add new indicators dynamically
        function addStockIndicator(text, container = document.body) {
            const indicator = document.createElement('p');
            indicator.className = 'delivery-time';
            indicator.textContent = text;
            container.appendChild(indicator);
            
            // Apply colors to the new indicator
            colorCoordinateStockIndicators();
            
            return indicator;
        }
        
        // Make functions available globally for external use
        window.colorCoordinateStockIndicators = colorCoordinateStockIndicators;
        window.addStockIndicator = addStockIndicator;